<template>
  <section id="site-prefooter" class="site-prefooter">
    <b-container>
      <div class="text-center mb-4">
        <div v-if="support_flow_enabled" class="h5 semibold">
          Serve assistenza?
        </div>
        <div v-else class="vb-heading h5">
          Parla con noi
        </div>
        <p v-if="!support_flow_enabled">
          dal lunedì al venerdì, dalle 9:00 alle 19:00
        </p>
      </div>
      <b-row class="dynamic-cols">
        <template v-if="support_flow_enabled">
          <div class="site-prefooter__support-col">
            <router-link :to="{ name: 'faq' }" class="site-prefooter__card">
              <feature-card
                icon="envelope"
                :icon_background_color="sass('gray-200')"
                radius
                centered
                title="Contattaci"
                text="Consulta le FAQ o compila il form per ottenere una risposta veloce e personalizzata."
              />
            </router-link>
          </div>
          <div class="site-prefooter__support-col">
            <customer-support-action cta_id="prefooter-webchat" class="site-prefooter__card">
              <feature-card
                icon="chat"
                :icon_background_color="sass('gray-200')"
                radius
                centered
                title="WebChat"
                text="Ottieni risposte e indicazioni in tempo reale con la nostra WebChat."
              />
            </customer-support-action>
          </div>
        </template>
        <template v-else>
          <b-col v-if="get_config('site.emailSupport', '')" xs="12" sm="6" lg="3">
            <div class="site-prefooter__block">
              <vb-icon class="site-prefooter__icon" :name="'email'" :dotted="true" />
              <div class="h6 vb-heading site-prefooter__title">
                Assistenza email
              </div>
              <div class="site-prefooter__text">
                <a :href="'mailto:'+get_config('site.emailSupport', '')" v-html="get_config('site.emailSupport', '')"></a>
              </div>
            </div>
          </b-col>
          <b-col v-if="get_config('site.phoneNumber', '')" xs="12" sm="6" lg="3">
            <div class="site-prefooter__block">
              <vb-icon class="site-prefooter__icon" :name="'phone'" :dotted="true" />
              <div class="h6 vb-heading site-prefooter__title">
                Assistenza telefonica
              </div>
              <div class="site-prefooter__text">
                <a :href="'phone:'+get_config('site.phoneNumber', '')" v-html="get_config('site.phoneNumber', '')+' | Chiama ora'"></a>
              </div>
            </div>
          </b-col>
          <b-col v-if="get_config('site.webChat', false)" xs="12" sm="6" lg="3">
            <div class="site-prefooter__block">
              <vb-icon class="site-prefooter__icon" :name="'chat'" :dotted="true" />
              <div class="h6 vb-heading site-prefooter__title">
                Webchat
              </div>
              <div class="site-prefooter__text">
                <customer-support-action cta_id="prefooter-webchat">Inizia la chat!</customer-support-action>
              </div>
            </div>
          </b-col>
          <b-col v-if="get_config('site.mobileNumber', '')" xs="12" sm="6" lg="3">
            <div class="site-prefooter__block">
              <vb-icon class="site-prefooter__icon" :name="'whatsapp'" :dotted="true" />
              <div class="h6 vb-heading site-prefooter__title">
                WhatsApp
              </div>
              <div class="site-prefooter__text">
                <a :href="get_config('site.waIntentLink', '')" v-html="get_config('site.mobileNumber', '') + ' | Parla con noi!'"></a>
              </div>
            </div>
          </b-col>
        </template>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import { is_support_flow_enabled } from '@/utilities/support_enabled'
import FeatureCard from '@/components/blocks/feature-card.vue'

export default {
  name: 'prefooter',
  components:
  {
    'feature-card': FeatureCard,
  },
  data() {
    return {
    }
  },
  computed: {
    support_flow_enabled: () => is_support_flow_enabled(),
  }
}
</script>

<style lang="scss">

  .site-prefooter {

    &__block {
      background: $white;
      text-align: center;
      border-radius: $border-radius-lg * 2;
      padding: $grid-gutter-width 0;
      margin: $grid-gutter-width/3 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    &__icon {
      display: flex;
      align-items: center;
      margin-bottom: $grid-gutter-width/2;

      .vb-icon {
        margin: auto;
        margin-bottom:1rem;

        svg {
          width: auto;
          height: 30px;
        }
      }
    }

    &__title {
    }

    &__text {
      font-size: $font-size-md;
    }

    &__support-col {
      flex: 0 1 295px + $grid-gutter-20;
      padding-right: $grid-gutter-20 / 2;
      padding-left: $grid-gutter-20 / 2;
    }

    &__support-col &__card {
      display: block;
      height: 100%;
      color: inherit;
      text-decoration: none;
      border-radius: $border-radius-lg * 2;
      transition: box-shadow .2s ease;

      &:hover,
      &:focus {
        color: inherit;
        box-shadow: $box-shadow-sm;
      }

      .feature-card .feature-card__icon {
        margin-bottom: $grid-gutter-width / 4;

        svg {
          width: 16px;
          height: 16px;
        }
      }

      .feature-card .feature-card__text {
        max-width: 220px;
        line-height: 1.15;
      }
    }

    @media print {
      display: none;
    }

    .dynamic-cols {
      justify-content: center;
      //&>* {
        //max-width: none;
        //flex: 1;
      //}
    }
  }

</style>